<div class="container my-5 blog-section">
  <h1 class="main-title text-center mb-4 text-uppercase fw-bold">{{ 'BLOG.TITLE' | translate }}</h1>

  <!-- Carousel for Mobile -->
  <div class="d-block d-md-none">
    <p-carousel [value]="blog" [numVisible]="1" [numScroll]="1" [circular]="true" [showIndicators]="false"
      [showNavigators]="blog.length > 1" [autoplayInterval]="2000" [responsiveOptions]="responsiveOptions"
      styleClass="custom-blog-carousel" dir="ltr">
      <ng-template pTemplate="item" let-item>
        <div class="carousel-item-wrapper blog-card" (click)="viewBlog(item.id)">
          <img [src]="item.img" alt="Blog image" class="carousel-image blog-image" />
          <p class="blog-category text-uppercase fw-semibold mb-1 mt-2">{{ item.category }}</p>
          <h6 class="blog-title mb-2">{{ item.title }}</h6>
          <p class="blog-author text-muted mb-0">By {{ item.by }}</p>
        </div>
      </ng-template>
    </p-carousel>
  </div>

  <!-- Grid for Desktop/Tablet -->
  <div class="row blog-list-wrapper d-none d-md-flex">
    <div class="blog-card-wrapper" *ngFor="let item of blog" (click)="viewBlog(item.id)">
      <div id="blogCard" class="blog-card">
        <img [src]="item.img" class="blog-image mb-3" alt="Blog image" />
        <p class="blog-category text-uppercase fw-semibold mb-1">{{ item.category }}</p>
        <h6 class="blog-title mb-2">{{ item.title }}</h6>
        <p class="blog-author text-muted mb-0 small">By {{ item.by }}</p>
      </div>
    </div>
  </div>

  <div class="text-center mt-4">
    <button routerLink="/products" class="btn btn-primary px-4 py-2">{{ 'VISIT_STORE' | translate }}</button>
  </div>
</div>